import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "./MUI/Icon";
import {toast} from "react-toastify";
import * as faceapi from 'face-api.js';

class ModalAuthVideo extends Component {

    state = {
        cameraIsStopped: false,
        userFaceDetected: false,

        profilePhotoUploaded: true,

        faces: 0,

        faceIsOK: false,

        preStartRecording: false,
        startRecording: false,
        stopRecording: false,
        counter: 6,
        startRecordingTime: Date.now(),

        faceIsNotValid: 0,

        loading: false
    };

    constructor() {
        super();
        this.videoRef = React.createRef();
        this.canvasRef = React.createRef();

        this.iv1 = null;
        this.iv2 = null;

        this.mediaRecorder = null;
        this.recordedChunks = [];

        this.wordPerSecond = 6;
    }

    async componentDidMount() {
        let {startRecording} = this.state;
        this.setState({profilePhotoUploaded: this.props.hasProfilePhoto});
        await this.openCamera();
        await this.loadModels();

        this.iv1 = setInterval(() => {
            this.checkFacePosition();
        }, 800);

        this.iv2 = setInterval(() => {
            if (startRecording) {
                this.checkFace();
            }
        }, 1500);

        setTimeout(() => {
            try {
                this.props.onCloseClick();
            } catch (err) {
            }
        }, 30 * 60 * 1000);
    }

    componentWillUnmount() {
        try {
            clearInterval(this.iv1);
            clearInterval(this.iv2);
        } catch (err) {
        }
    }

    // -------------------------------------------------------------

    // <Camera> ------------------

    async openCamera() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {facingMode: "user"},
                audio: true
            });
            const videoElement = this.videoRef.current;
            videoElement.srcObject = stream;
            // videoElement.play();
        } catch (err) {
            toast.error("باید دسترسی به دوربین بدهید!");
        }
    };

    stopCamera() {
        try {
            const stream = this.videoRef.current.srcObject;
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
                this.videoRef.current.srcObject = null;
                this.setState({cameraIsStopped: true});
            }
        } catch (err) {
        }
    };

    closeModal(t = true) {
        if (t) {
            toast.error("احراز هویت ناموفق!", {autoClose: 4000});
        }
        try {
            this.stopCamera();
        } catch (err) {
        }
        try {
            clearInterval(this.iv1);
            clearInterval(this.iv2);
        } catch (err) {
        }
        try {
            this.setState({
                cameraIsStopped: false,
                stopRecording: true,
                preStartRecording: false,
                startRecording: false,
                faceIsOK: false,
                loading: false
            });
        } catch (err) {
        }
        try {
            if (this.props.onCloseClick) {
                this.props.onCloseClick();
            }
        } catch (err) {
        }
        return true;
    };

    // async loadModels() {
    //     await faceapi.nets.tinyFaceDetector.loadFromUri('https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@master/weights');
    // };

    // </Camera> -----------------

    // -------------------------------------------------------------


    async loadModels() {
        await faceapi.nets.tinyFaceDetector.loadFromUri('/face-models');
    }

    // <Check Face> ----------------

    async checkFacePosition() {
        let {cameraIsStopped, faceIsOK} = this.state;
        try {
            if (faceIsOK) {
                return true;
            }
            if (!cameraIsStopped) {
                const video = this.videoRef.current;
                if (video) {
                    const {videoWidth, videoHeight} = video;

                    const detections = await faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions());
                    const detection = await faceapi.detectSingleFace(video, new faceapi.TinyFaceDetectorOptions());

                    let count = detections ? detections.length : 0;
                    count = count ? count : 0;

                    this.setState({
                        faces: count
                    });

                    if (count === 1) {
                        if (detection) {
                            const left = videoWidth * 0.2;
                            const right = videoWidth * 0.8;
                            const top = videoHeight * 0.2;
                            const bottom = videoHeight * 0.8;

                            const {box} = detection;
                            const isInside =
                                box.x > left &&
                                box.y > top &&
                                box.x + box.width < right &&
                                box.y + box.height < bottom;

                            if (isInside) {
                                this.setState({
                                    userFaceDetected: true,
                                    faceIsOK: true
                                });
                                let {profilePhotoUploaded} = this.state;
                                if (!profilePhotoUploaded) {
                                    this.captureFrame();
                                }
                            } else {
                                this.setState({userFaceDetected: false});
                            }
                        }
                    } else {
                        this.setState({userFaceDetected: false});
                    }
                }
            }
        } catch (err) {
        }
    };

    async checkFace() {
        try {
            let {startRecording, faceIsOK, faceIsNotValid} = this.state;
            if (startRecording && faceIsOK) {
                if (faceIsNotValid > 20) {
                    toast.error("چهره شما شناسایی نشد؛ توجه داشته باشید که فقط یک چهره در ویدیو وجود داشته باشد!", {autoClose: 5000});
                    return this.closeModal(true);
                }
                const video = this.videoRef.current;
                if (video) {
                    const detections = await faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions());
                    let count = detections ? detections.length : 0;
                    count = count ? count : 0;

                    this.setState({
                        faces: count
                    });

                    if (count === 0 || count >= 2) {
                        let {faceIsNotValid} = this.state;
                        faceIsNotValid = faceIsNotValid ? faceIsNotValid : 0;
                        if (typeof faceIsNotValid !== "number") {
                            faceIsNotValid = 0;
                        }
                        faceIsNotValid = (faceIsNotValid + 1);
                        this.setState({
                            faceIsNotValid
                        });
                    }
                }
            }
        } catch (err) {
        }
        return true;
    };

    // </Check Face> ---------------

    // -------------------------------------------------------------

    // <Profile Photo> ---------

    captureFrame() {
        const video = this.videoRef.current;
        const canvas = this.canvasRef.current;
        let {profilePhotoUploaded} = this.state;
        if (!video || !canvas || profilePhotoUploaded) return;

        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;

        canvas.width = videoWidth;
        canvas.height = videoHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight);

        const squareSize = Math.min(videoWidth, videoHeight);
        const startX = (videoWidth - squareSize) / 2;
        const startY = (videoHeight - squareSize) / 2;

        const croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = squareSize;
        croppedCanvas.height = squareSize;

        const croppedCtx = croppedCanvas.getContext('2d');
        croppedCtx.drawImage(
            canvas,
            startX, startY, squareSize, squareSize,
            0, 0, squareSize, squareSize
        );

        const base64Image = croppedCanvas.toDataURL('image/png');

        try {
            if (this.props.handleUploadProfilePhoto) {
                this.props.handleUploadProfilePhoto(base64Image);
            }
        } catch (err) {
        }
        this.setState({profilePhotoUploaded: true});
    };

    // </Profile Photo> ---------

    // -------------------------------------------------------------

    // <Upload-Video> --------------------------

    async handleStartRecording() {
        this.setState({
            counter: 5,
            startRecordingTime: Date.now(),
            preStartRecording: true
        });

        let iv = setInterval(async () => {
            let {counter} = this.state;
            if (counter >= 1) {
                this.setState({
                    counter: (counter - 1)
                });
            } else {
                this.setState({
                    counter: 0
                });
                try {
                    const stream = this.videoRef.current.srcObject;
                    if (stream) {
                        stream.getTracks().forEach(track => track.stop());
                        this.videoRef.current.srcObject = null;
                    }
                } catch (err) {
                }
                try {
                    const estimatedSeconds = (Math.ceil((this.props.authText?.toString().trim()
                        .replace(/  /g, " ").trim()
                        .split(" ").length) / this.wordPerSecond));

                    const stream = await navigator.mediaDevices.getUserMedia({video: true, audio: true});
                    this.videoRef.current.srcObject = stream;

                    this.setState({
                        startRecording: true,
                        stopRecording: false,
                        startRecordingTime: Date.now(),
                        loading: false
                    });

                    this.mediaRecorder = new MediaRecorder(stream);
                    this.recordedChunks = [];

                    this.mediaRecorder.ondataavailable = (e) => {
                        if (e.data.size > 0) this.recordedChunks.push(e.data);
                    };

                    this.mediaRecorder.start();

                    setTimeout(() => {
                        this.handleStopRecording();
                    }, ((estimatedSeconds * 1000) + 8500));

                } catch (err) {
                    toast.error("باید دسترسی به دوربین بدهید!");
                    this.closeModal(false);
                }
                return clearInterval(iv);
            }
        }, 1050);
        return true;
    }

    handleStopRecording() {
        try {
            let {startRecordingTime} = this.state;
            this.mediaRecorder.stop();
            this.mediaRecorder.onstop = () => {
                const blob = new Blob(this.recordedChunks, {type: "video/webm"});
                // const videoURL = URL.createObjectURL(blob);

                const duration = (Date.now() - startRecordingTime) / 1000;

                if (duration > 30) {
                    toast.error("مدت زمان ویدیو ضبط شده طولانی است!");
                    return this.closeModal(true);
                }
                try {
                    if (this.props.handleUploadAuthVideo) {
                        this.setState({loading: true});
                        this.props.handleUploadAuthVideo(blob);
                    }
                } catch (err) {

                }
            };
            const stream = this.videoRef.current.srcObject;
            stream.getTracks().forEach(track => track.stop());
            this.videoRef.current.srcObject = null;
        } catch (err) {
            console.error("handleStopRecording: ", err);
        }

    };


    // </Upload-Video> -------------------------

    render() {
        const {display} = this.props;
        if (!display) {
            return null;
        }
        let {authText} = this.props;
        authText = authText ? authText.toString().trim() : "";

        let {
            cameraIsStopped, userFaceDetected, faces, faceIsOK,
            counter, startRecording, stopRecording, preStartRecording,
            loading
        } = this.state;
        return (
            <>
                <canvas ref={this.canvasRef} style={{display: 'none'}}/>
                <div className="modal-auth-video">
                    <div className="card">
                        <div className="head">
                            <div className="row">
                                <div className="col-auto">
                                    <Icon i="close" solid className="close-icon"
                                          onClick={() => {
                                              if (!loading) {
                                                  this.closeModal(false);
                                              }
                                          }}/>
                                </div>
                                <div className="col">
                                    <div className="title">احراز هویت</div>
                                </div>
                            </div>
                        </div>
                        <div className="body">
                            {
                                !cameraIsStopped && !loading ?
                                    <div className="video">
                                        <video id="video"
                                               style={userFaceDetected ? {border: "1px solid rgba(0, 182, 30, 1)"} : {}}
                                               ref={this.videoRef}
                                               playsInline
                                               autoPlay
                                               muted/>
                                        {
                                            counter >= 0 && counter < 6 && !loading ?
                                                <div className="interval">
                                                    {
                                                        <div className="iv">
                                                            {
                                                                counter > 0 ?
                                                                    <span
                                                                        className="counter">{counter.toString()}</span>
                                                                    :
                                                                    !startRecording ?
                                                                        <div style={{
                                                                            fontSize: "11pt",
                                                                            textAlign: "center",
                                                                            color: "#ffffff",
                                                                            textShadow: "0 1px 5px rgba(0,0,0,0.5)"
                                                                        }}>در حال آماده سازی ...</div>
                                                                        : null
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                : null
                                        }

                                        {
                                            startRecording ?
                                                <div className="start-recording">
                                                    <div className="t">در حال ضبط ...</div>
                                                    <div className="start-auth-text">{authText}</div>
                                                </div>
                                                : null
                                        }
                                        {
                                            !startRecording ?
                                                <div className="sample-face">
                                                    <span className="bordered">
                                                        <span className={userFaceDetected ? "border active" : "border"}>
                                                        </span>
                                                    </span>
                                                </div>
                                                : null
                                        }
                                    </div>
                                    :
                                    loading ?
                                        <div className="loading-upload">
                                            <p className="t">
                                                <Icon i="refresh"/>
                                                <span>در حال بارگذاری ویدیو برای بررسی ...</span>
                                            </p>
                                            <br/>
                                            <p className="note" style={{color: "#9d2020"}}>تا نتیجه بررسی ویدیو
                                                ارسالی <strong>به هیچ
                                                    وجه</strong> از این صفحه خارج نشوید!</p>
                                            <br/>
                                            <p className="note">توجه داشته باشید که فرآیند احراز هویت به صورت خودکار
                                                انجام می شود.</p>
                                        </div>
                                        : null
                            }
                            {
                                (!userFaceDetected || faces === 0) && !loading ?
                                    <div className="face-not-detected">صورت خود را داخل کادر قرار بدهید!</div>
                                    : null
                            }
                            {
                                faces > 1 && !loading ?
                                    <div className="face-not-detected" style={{marginTop: -60}}>فقط یک نفر باید داخل
                                        ویدیو
                                        باشد!</div>
                                    : null
                            }
                            {
                                faceIsOK && !preStartRecording ?
                                    <div className="start-record">
                                        <div className="btn" onClick={() => this.handleStartRecording()}>
                                            <Icon i="record-vinyl"
                                                  className="record-icon"/>
                                            <span className="t">شروع ضبط</span>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                        {faceIsOK && !startRecording && !loading ?
                            <div className="foot">
                                <div className="auth-text-modal">
                                    <p className="t">متن زیر را با صدای رسا و بلند بخوانید:</p>
                                    <p className="txt">{authText}</p>
                                </div>
                            </div>
                            : null}

                    </div>
                </div>
            </>
        );
    }
}

export default gpn(ModalAuthVideo);